import skipImage from '../../assets/img/skip.svg';
import warningImage from '../../assets/img/warning.svg';

const cacheImages = () => {
    new Image().src = skipImage;
    new Image().src = warningImage;
};

/** cache images in javascript only if window is loaded **/
const preloadImages = () => {
    if (document.readyState === 'complete') {
        cacheImages();
    } else {
        window.addEventListener('load', cacheImages);
    }
};

export default preloadImages;
